import {
  BasicButton,
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  Modal,
  Stack,
  Text,
} from "@certn/cascadia-react";
import { Trans, useTranslation } from "react-i18next";

import { CheckInBundleConflict } from "./bundle-conflict-utils";

type CheckInBundleConflictModalProps = {
  isOpen: boolean;
  conflict: CheckInBundleConflict | null;
  onClose: () => void;
};

export function CheckInBundleConflictModal({
  isOpen,
  conflict,
  onClose,
}: CheckInBundleConflictModalProps) {
  const { t } = useTranslation();

  if (!conflict) {
    return null;
  }

  return (
    <Modal isOpen={isOpen} testID="check-in-bundle-conflict-modal">
      <Dialog>
        <DialogHeader onClose={onClose}>
          {t("Check already included")}
        </DialogHeader>
        <DialogContent>
          <Stack gap="space-4">
            <Text style="global/body-primary">
              <Trans>
                This check is already included in a bundled deal on this
                package. Bundled deals include their own checks, so you cannot
                add it again as an individual check.
              </Trans>
            </Text>
            <Text style="global/body-primary">
              <strong>
                <Trans>Check</Trans>:
              </strong>{" "}
              {conflict.check.name}
            </Text>
            <Text style="global/body-primary">
              <strong>
                <Trans>Included in bundled deal</Trans>:
              </strong>{" "}
              {conflict.bundleTitles.join(", ")}
            </Text>
          </Stack>
        </DialogContent>
        <DialogFooter>
          <BasicButton size="medium" onPress={onClose} testID="close-button">
            <Trans>Got it</Trans>
          </BasicButton>
        </DialogFooter>
      </Dialog>
    </Modal>
  );
}
